exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".trigger {\n  font-size: 18px;\n  line-height: 64px;\n  padding: 0 24px;\n  cursor: pointer;\n  transition: color .3s; }\n  .trigger:hover {\n    color: #1890ff; }\n\n.logo {\n  height: 32px;\n  background: rgba(255, 255, 255, 0.2);\n  margin: 16px; }\n\n.ant-layout .header {\n  background: #fff;\n  padding: 0; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/sass-loader/lib/loader.js?{}!./src/main/style.scss
// module id = 249
// module chunks = 0